export enum ProfilViewType {
  MY_PROFIL,
  BETREIBER_VIEW,
  PATIENTEN_VIEW,
  THERAPEUTEN_VIEW,
}